import React,{useEffect} from "react";
import { useLocation, useNavigate } from "react-router-dom";
import http from "../services/http";
import GetStorage from "../services/Storage";

function PreviewVideo() {

  const location = useLocation();
  const { name,id,type } = location.state;
  const navigate = useNavigate();
  const token = GetStorage.get("xAuthToken");

  useEffect(() => {
    incrementViews();
  }, [id]);

  const incrementViews = async () => {
    // setTimeout(() => {
      if(type != "evo_order"){
        http
          .put(`api/common/view/increment?token=${token}`, {
            recording_id: id,
          })
          .then((res) => {
            // console.log("recording", res.data);
          })
          .catch((error) => {
            // console.log("error", error);
          });
      }
    // }, 3000);
  };

  return (
    <>
    <div className="align-items-start position-relative">
      <svg
        onClick={() => navigate(-1)}
        style={{
          color: "white",
          width: "20px",
          height: "20px",
          marginLeft: 20,
          marginTop: 20,
        }}
        viewBox="4 4 33.583 27.008"
      >
        <path
          id="Path_83491"
          d="M 37.58322906494141 15.81591987609863 L 10.46499538421631 15.81591987609863 L 19.90085029602051 6.380063056945801 L 17.50390815734863 3.999999761581421 L 3.999999761581421 17.50390815734863 L 17.50390815734863 31.0078125 L 19.88397026062012 28.62774848937988 L 10.46499538421631 19.19189453125 L 37.58322906494141 19.19189453125 L 37.58322906494141 15.81591987609863 Z"
        ></path>
      </svg>
    </div>
      <div>
        <video
          style={{ objectFit: "contain", width: "100%", height: "96vh" }}
          src={name}
          controls
          controlsList={"nofullscreen"}
          autoPlay
        >
        </video>
      </div>
    </>
  );
}

export default PreviewVideo;
